import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCity, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './FavoritesSwitch.css';
//
// Компонент для переключения режима отображения
// с показа экспонентов на показ активностей и обратно.
//
const FavoritesSwitch = ({ mode, setMode }) => {
	const { t } = useTranslation();

	return (
		<div className='FavoritesSwitch'>
			<span
				onClick={() => setMode('exhibitors')}
				className={mode === 'exhibitors' ? 'Selected' : undefined}
			>
				<Icon icon={faCity} size='sm'/>&nbsp;
				{t('favorites.exhibitors')}
			</span>
			<span
				onClick={() => setMode('activities')}
				className={mode === 'activities' ? 'Selected' : undefined}
			>
				<Icon icon={faCalendar} size='sm'/>&nbsp;
				{t('favorites.activities')}
			</span>
		</div>
	);
};

FavoritesSwitch.propTypes = {
    mode: PropTypes.oneOf(['exhibitors','activities']).isRequired,
	setMode: PropTypes.func.isRequired,
};

export default FavoritesSwitch;
